module.exports = {"__schema":{"types":[]}}


//////////////////
// WEBPACK FOOTER
// ./src/graphql/fragmentTypes.json
// module id = 736
// module chunks = 0